import { render, staticRenderFns } from "./LinkIcon.vue?vue&type=template&id=065caae5&"
import script from "./LinkIcon.vue?vue&type=script&lang=js&"
export * from "./LinkIcon.vue?vue&type=script&lang=js&"
import style0 from "./LinkIcon.vue?vue&type=style&index=0&id=065caae5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports